import { ActionBtn, DatePicker, DropDown, FileUpload, InputField, TextArea } from '@/components/Exporter'
import { useTranslation } from 'react-i18next'
import "./style.css"
import useForm from '@/hooks/useForm'
import MultiSelect from '@/components/formFields/DropDown/Multiselect'
import RedioBtns from '@/components/formFields/RedioBtns';
import { GetCountryLookup, GetNationalitiesLookup } from '@/api/endpoints/Country'
import { SUPPORTED_FORMATS } from '@/components/popups/filesUploadPopup/components/UploadFile'
import Popup from '@/components/popup'
import { useState } from 'react'
import { defaultFiles } from '../UploadPatientMedicalFiles'
import { GetCatgoryLookup, GetSubCatgoryLookup } from '@/api/endpoints'
import { SERVICES_TYPES } from '@/data/Constant'
import { useAddPatient, yesNoChoices, genderChoices, MaritalStatusChoices } from './useAddPatient'
import FormSection from './FormSection'
import { CRRender } from '@/components/crRender'

const lang = "any"

const AddPatientPopup = ({ modalId, patientId, selectedPatient }) => {
  const { t } = useTranslation()
  const { onSubmit, onReset, formHandler } = useForm()
  const {loading,files,setFiles,patientData,isPending,handleSubmit,isEditing} = useAddPatient({modalId, patientId, selectedPatient, onReset,    })
  const [selectedFileType, setSelectedFileType] = useState(null)
  const GetMedicalCategories = () => GetCatgoryLookup(SERVICES_TYPES.Medical)

  return (
    <Popup needbtn={false} large={true} modalID={modalId} name={isEditing ? 'edit-patient-data' : 'add-new-patient'} title={t(isEditing ? 'edit-patient-data' : 'add-new-patient')} >
    <div className="add-patient-wrapper">
      <div className="add-patient-modal">
        <div className="modal-body">
          <FormSection title="personal-and-identity" icon="solar:user-id-bold-duotone" cols={3}>
            <InputField min={3} max={36} lang={lang} formHandler={formHandler} isRequired isLoading={isPending} name="groupName" placeholder='e.g. Alliance_Corp_01' defaultValue={selectedPatient?.groupName} />
            <InputField min={3} max={36} lang={lang} formHandler={formHandler} isRequired isLoading={isPending} name="firstName" placeholder='John' defaultValue={patientData?.firstName} />
            <InputField min={3} max={36} lang={lang} formHandler={formHandler} isRequired isLoading={isPending} name="lastName" placeholder='Doe' defaultValue={patientData?.lastName} />
            <RedioBtns isRequired className="col-12 redio-btns" name="gender" label={t('gender')}  List={genderChoices} formHandler={formHandler} defaultValue={patientData?.gender} />
            <RedioBtns isRequired className="col-12 redio-btns" name="requiresVisa" label={t("requires-visa")} List={yesNoChoices} formHandler={formHandler} defaultValue={patientData?.requiresVisa} />
            <DatePicker isSingle={true} lang={lang} className=" col-md-12 date-picker" maxDate={2008} minDate={1900} isRequired name="birthDate" formHandler={formHandler} isLoading={isPending}  defaultValue={patientData?.birthDate} />
            <DropDown defaultValue={patientData?.nationalityId} isMulti={false} label="nationality"  endPoint={GetNationalitiesLookup} formHandler={formHandler} />
            <DropDown defaultValue={patientData?.countryId} isMulti={false} label="country" endPoint={GetCountryLookup} formHandler={formHandler} />
            <InputField lang={lang} formHandler={formHandler} isRequired isLoading={isPending} name="passportNumber" placeholder='P12345678' defaultValue={patientData?.passportNumber} />
          </FormSection>
          <FormSection title="contact-and-logistics" icon="solar:phone-calling-bold-duotone" cols={2}>
            <InputField lang={lang} formHandler={formHandler} isRequired isLoading={isPending} type="email" name="email" placeholder='patient@example.com' defaultValue={patientData?.email} />
            <InputField lang={lang} formHandler={formHandler} isRequired isLoading={isPending} type="tel" name="phoneNumber" placeholder='+971 50 123 4567' defaultValue={patientData?.phoneNumber} />
          </FormSection>
          <FormSection title="clinical-and-treatment" icon="solar:notes-bold-duotone" cols={1}>
            <TextArea 
              min={10}
              max={1200}
              isRequired
              name="medicalDiagnosis"
              label='medicalDiagnosis'
              lang={lang}
              defaultValue={patientData?.medicalDiagnosis}
              formHandler={formHandler}
              placeholder='Describe clinical condition...'
              value={formHandler.formValues?.medicalDiagnosis?.value}
              isError={formHandler.formValues?.medicalDiagnosis?.isError}
              setValue={(val) => formHandler.handleFormValues("medicalDiagnosis", { value: val, isRequired: true, isError: false })}
            />
            <div className="dual-row">
              <DropDown defaultValue={patientData?.serviceCategoryId} endPoint={GetMedicalCategories} isMulti={false} label='service' isRequired formHandler={formHandler}   />
              <DropDown
                defaultValue={patientData?.serviceSubCategoryId}
                endPoint={GetSubCatgoryLookup}
                params={["service"]}
                isAllowedToFetch={Boolean(formHandler?.formValues?.service?.value?.value || patientData?.serviceCategoryId)}
                isMulti={false}
                label='sub-service-category'
                isRequired
                formHandler={formHandler}
              />
            </div>  
          </FormSection>
          <FormSection title="logistics-and-dates" icon="solar:calendar-bold-duotone" cols={2}>
            <DatePicker name="treatmentStartDate" label="treatment-start-date" minDate={new Date()} isRequired className=" col-md-12 date-picker" formHandler={formHandler} isSingle={true} defaultValue={patientData?.treatmentStartDate} />
            <DatePicker name="treatmentEndDate" label="treatment-end-date" minDate={new Date()} isRequired className=" col-md-12 date-picker" formHandler={formHandler} isSingle={true} defaultValue={patientData?.treatmentEndDate} />
         </FormSection>
          <FormSection cols={3} >
            <RedioBtns className="col-12 redio-btns" name="requiresVisa" label={t("requires-visa")} List={yesNoChoices} formHandler={formHandler} isRequired defaultValue={patientData?.requiresVisa} />
            <RedioBtns className="col-12 redio-btns" name="requiresAccommodation" label={t("requires-accommodation")} List={yesNoChoices} formHandler={formHandler} isRequired defaultValue={patientData?.requiresAccommodation} />
            <RedioBtns className="col-12 redio-btns" name="requiresFlight" label={t("requires-flight")} List={yesNoChoices} formHandler={formHandler} isRequired defaultValue={patientData?.requiresFlight} />
          </FormSection>
          <CRRender isRender={!isEditing}>
             <FormSection title="upload-medical-records" icon="solar:upload-minimalistic-bold-duotone" cols={1}>
            <div className="upload-composite">
              <div className="doc-type-box">
                 <MultiSelect isRequired formHandler={formHandler} options={Object.values(defaultFiles).map(item => ({ label: item, value: item }))}
                    className='col-lg-12'
                    label={'docType'}
                    isMulti={false}
                    sOptions={selectedFileType?.value}
                    setSOptions={(sel) => { setSelectedFileType(sel?.value) }}
                  />
                </div>
                <FileUpload
                  accept={[SUPPORTED_FORMATS.image, SUPPORTED_FORMATS.pdf, SUPPORTED_FORMATS.word, SUPPORTED_FORMATS.excel, SUPPORTED_FORMATS.text, SUPPORTED_FORMATS.presentation, SUPPORTED_FORMATS.video, SUPPORTED_FORMATS.audio, SUPPORTED_FORMATS.archive, SUPPORTED_FORMATS.code]}
                  multiple
                  value={files[selectedFileType] || []}
                  setValue={(value) => setFiles(prev => ({ ...prev, [selectedFileType]: value }))}
                  label={t("upload-medical-files-hint")}
                  isRequired={true}
                />
              </div>
            </FormSection>
          </CRRender>
          <CRRender isRender={isEditing}>
             <FormSection cols={1} title="biometric-data" icon="streamline-flex-color:dna-flat">
            <FormSection cols={2}>
              <InputField type="number" lang={lang} formHandler={formHandler} isRequired isLoading={isPending} name="height" placeholder='170' defaultValue={patientData?.height}  />
              <InputField type="number" lang={lang} formHandler={formHandler} isRequired isLoading={isPending} name="weight" placeholder='70' defaultValue={patientData?.weight} />
            </FormSection>
            <FormSection cols={3} >
              <RedioBtns className="col-12 redio-btns" name="maritalStatus" label="marital-status"  List={MaritalStatusChoices} formHandler={formHandler} defaultValue={patientData?.maritalStatus} />
              <RedioBtns className="col-12 redio-btns" name="isSmoker" label="do-you-smoke"  List={yesNoChoices} formHandler={formHandler} defaultValue={patientData?.isSmoker} />
              <RedioBtns className="col-12 redio-btns" name="isDrinkAlcohol" label="do-you-drink-alcohol"  List={yesNoChoices} formHandler={formHandler} defaultValue={patientData?.isDrinkAlcohol} />
            </FormSection>
            <FormSection cols={1}>
            <InputField type="text" lang={lang} formHandler={formHandler} isRequired isLoading={isPending} name="checkoutOperation" placeholder='Ex: Appendectomy' defaultValue={patientData?.medicalOperation}  />
            <InputField type="text" lang={lang} formHandler={formHandler} isRequired isLoading={isPending} name="checkoutAllergy" placeholder='Ex: Penicillin' defaultValue={patientData?.allergy} />
            <InputField type="text" lang={lang} formHandler={formHandler} isRequired isLoading={isPending} name="checkoutMedication" placeholder='Ex: Aspirin' defaultValue={patientData?.regularMedicationName} />
           </FormSection>
            {/* <TextArea
            min={10}
            max={1200}
                name="familyMedicalHistory"
                label="familyMedicalHistory"
                placeholder="Enter medical family history..."
                defaultValue={patientData?.familyMedicalHistory}
                value={formHandler.formValues?.familyMedicalHistory?.value || ""}
                setValue={(value) => formHandler.handleFormValues("familyMedicalHistory", { value, isRequired: true, isError: false })}
                isError={formHandler.formValues?.familyMedicalHistory?.isError}
                isRequired
                cols={1}
                lang={lang}
              /> */}
        </FormSection>
          </CRRender>
        </div>
        <div className="modal-footer">
          <ActionBtn onApply={onReset} className="cancel-btn" title={t("cancel")} icon="solar:close-circle-bold" />
          <ActionBtn onApply={() => onSubmit(handleSubmit)} className="submit-btn" title={t(isEditing ? "edit-patient-data" : "add-patient")} icon="solar:check-circle-bold" isLoading={loading} />
        </div>
      </div>
    </div>
    </Popup>
  )
}

export default AddPatientPopup
